import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// translations files
import ar_translations from 'translations/ar';
import en_translations from 'translations/en';
import es_translations from 'translations/es';
import hi_translations from 'translations/hi';
import pt_translations from 'translations/pt';
import se_translations from 'translations/se';
import ga_translations from 'translations/ga';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    whitelist: ["en", "es", "se", "pt", "ar", "hi", "ga"],
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    detection: {
      order: ["localStorage", "cookie"],
      chaches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      ar: { translations: ar_translations },
      en: { translations: en_translations },
      es: { translations: es_translations },
      hi: { translations: hi_translations },
      pt: { translations: pt_translations },
      se: { translations: se_translations },
      ga: { translations: ga_translations },
    }
  });

export default i18n;
